import { SVGProps } from "react"

type IconProps = SVGProps<SVGSVGElement>

/** Presentation screen with slide layout lines and a play triangle — filled */
export function SlidesIcon(props: IconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            {...props}
        >
            {/* Filled screen */}
            <rect x="2" y="3" width="20" height="14" rx="2" fill="currentColor" />
            {/* Stand */}
            <line x1="12" y1="17" x2="12" y2="21" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" />
            <line x1="8" y1="21" x2="16" y2="21" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" />
            {/* Slide content lines */}
            <line x1="6" y1="7" x2="11" y2="7" stroke="white" strokeWidth={1.4} strokeLinecap="round" />
            <line x1="6" y1="10" x2="9" y2="10" stroke="white" strokeWidth={1.4} strokeLinecap="round" />
            {/* Play triangle */}
            <polygon points="15,8 15,13 19,10.5" fill="white" opacity={0.85} />
        </svg>
    )
}

/** Upward arrow emerging from a bar chart — fundraising growth — filled */
export function PitchDeckIcon(props: IconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            {...props}
        >
            {/* Filled bar chart bars */}
            <rect x="3" y="14" width="3.5" height="7" rx="0.8" fill="currentColor" opacity={0.55} />
            <rect x="8.5" y="10" width="3.5" height="11" rx="0.8" fill="currentColor" opacity={0.75} />
            <rect x="14" y="6" width="3.5" height="15" rx="0.8" fill="currentColor" />
            {/* Upward arrow */}
            <line x1="20" y1="10" x2="20" y2="3" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" />
            <polyline points="17.5,5.5 20,3 22.5,5.5" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round" fill="none" />
        </svg>
    )
}

/** Pie chart with symmetric equity segments — ownership structure — filled */
export function CapTableIcon(props: IconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            {...props}
        >
            {/* Three symmetric 120° sectors */}
            {/* Sector 1: top-right (0° → 120°) */}
            <path d="M12 12 L12 3 A9 9 0 0 1 19.79 16.5 Z" fill="currentColor" opacity={0.9} />
            {/* Sector 2: bottom (120° → 240°) */}
            <path d="M12 12 L19.79 16.5 A9 9 0 0 1 4.21 16.5 Z" fill="currentColor" opacity={0.55} />
            {/* Sector 3: top-left (240° → 360°) */}
            <path d="M12 12 L4.21 16.5 A9 9 0 0 1 12 3 Z" fill="currentColor" opacity={0.3} />
            {/* White divider lines */}
            <line x1="12" y1="12" x2="12" y2="3" stroke="white" strokeWidth={1.2} strokeLinecap="round" />
            <line x1="12" y1="12" x2="19.79" y2="16.5" stroke="white" strokeWidth={1.2} strokeLinecap="round" />
            <line x1="12" y1="12" x2="4.21" y2="16.5" stroke="white" strokeWidth={1.2} strokeLinecap="round" />
        </svg>
    )
}

/** Single document page with text lines — filled */
export function DocumentsIcon(props: IconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            {...props}
        >
            {/* Single filled document */}
            <rect x="4" y="2" width="16" height="20" rx="2" fill="currentColor" />
            {/* Text lines */}
            <line x1="8" y1="7" x2="15" y2="7" stroke="white" strokeWidth={1.4} strokeLinecap="round" />
            <line x1="8" y1="10.5" x2="13" y2="10.5" stroke="white" strokeWidth={1.4} strokeLinecap="round" />
            <line x1="8" y1="14" x2="14" y2="14" stroke="white" strokeWidth={1.4} strokeLinecap="round" />
        </svg>
    )
}

/** Globe with magnifying glass — deep market analysis — filled */
export function ResearchIcon(props: IconProps) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            {...props}
        >
            {/* Filled globe */}
            <circle cx="10.5" cy="10.5" r="8" fill="currentColor" />
            {/* Globe lines */}
            <ellipse cx="10.5" cy="10.5" rx="3.5" ry="8" stroke="white" strokeWidth={1.2} fill="none" />
            <line x1="2.5" y1="8" x2="18.5" y2="8" stroke="white" strokeWidth={1.2} strokeLinecap="round" />
            <line x1="2.5" y1="13" x2="18.5" y2="13" stroke="white" strokeWidth={1.2} strokeLinecap="round" />
            {/* Magnifying glass handle */}
            <line x1="16.5" y1="16.5" x2="22" y2="22" stroke="currentColor" strokeWidth={2.2} strokeLinecap="round" />
        </svg>
    )
}
